import { useGetInvoiceReportsPaymentStatuses } from '@/context/services/invoice_reports/InvoiceReportSearch.service';
import type { ValueTransformer } from '@/hooks/invoice_reports/useShowSearchValue';
import { useCallback, useMemo } from 'react';

/**
 * Hook that provides payment_status custom transformer for useShowSearchValue.
 * Resolves payment status values to display labels from the API.
 */
export const usePaymentStatusTransformer = () => {
  const { data: paymentStatusesData } = useGetInvoiceReportsPaymentStatuses();

  const paymentStatusValueToLabel = useMemo(() => {
    const items = Array.isArray(paymentStatusesData)
      ? paymentStatusesData
      : paymentStatusesData?.data ?? [];
    const map: Record<string, string> = {};
    for (const item of items) {
      if (item.value !== undefined && item.display_name !== undefined) {
        map[item.value] = item.display_name;
      }
    }
    return map;
  }, [paymentStatusesData]);

  const paymentStatusTransformer: ValueTransformer = useCallback(
    (value) => {
      if (typeof value !== 'string') return '';
      return paymentStatusValueToLabel[value] ?? value;
    },
    [paymentStatusValueToLabel]
  );

  return useMemo(
    () => ({
      payment_status: paymentStatusTransformer,
    }),
    [paymentStatusTransformer]
  );
};
